export const DASHBOARD = {
  page: "dashboard-page",
  kpiSpend: "kpi-spend",
  kpiLeads: "kpi-leads",
  kpiCpl: "kpi-cpl",
  kpiClosed: "kpi-closed",
  kpiRevenue: "kpi-revenue",
  kpiRoas: "kpi-roas",
  pieChart: "source-pie-chart",
  trendChart: "trend-chart",
  platformTable: "platform-breakdown-table",
};

export const FORECAST = {
  page: "forecast-page",
  newBtn: "scenario-new-btn",
  modeAToggle: "mode-a-toggle",
  modeBToggle: "mode-b-toggle",
  targetRevenue: "target-revenue-input",
  saveBtn: "scenario-save-btn",
  compareTable: "scenario-compare-table",
  goalSeekResult: "goal-seek-result",
};
